import type { ParamConfig, SelectOption } from '@diamond/shared/types';

import type { CreateVoucherRequest } from '../types';

export const VOUCHER_QUERY_KEY = 'vouchers';
export const VOUCHER_PAGE_SIZE = 10;

export const VOUCHER_STATUS_OPTIONS: SelectOption[] = [
  { value: '', label: 'Semua Status' },
  { value: 'ACTIVE', label: 'Aktif' },
  { value: 'INACTIVE', label: 'Tidak Aktif' },
  // { value: 'EXPIRED', label: 'Kedaluwarsa' },
];

export const VOUCHER_MECHANISM_OPTIONS: SelectOption[] = [
  { value: '', label: 'Semua Mekanisme' },
  { value: 'DISCOUNT_PERCENT', label: 'Diskon %' },
  { value: 'DISCOUNT_AMOUNT', label: 'Diskon Nominal' },
  { value: 'FREE_GOODS', label: 'Free Goods' },
];

export const TARGET_VOUCHER_OPTIONS = [
  { value: 'general', label: 'Umum' },
  { value: 'ship-to', label: 'Spesifik Ship to' },
] as const;

export const ACQUISITION_METHOD_OPTIONS = [
  { value: 'activation', label: 'Aktivasi akun' },
  { value: 'automatic', label: 'Reguler' },
  { value: 'coupon', label: 'Kode kupon' },
] as const;

export const ACCOUNT_AGE_OPTIONS = [
  { value: '7-days', label: '7 hari' },
  { value: '14-days', label: '14 hari' },
  { value: '30-days', label: '30 hari' },
  { value: '60-days', label: '60 hari' },
] as const;

export const VOUCHER_REQUIREMENT_TYPE_OPTIONS = [
  { value: 'regular', label: 'Reguler' },
  { value: 'special', label: 'Khusus' },
] as const;

export const VOUCHER_REWARD_TYPE_OPTIONS = [
  { value: 'amount', label: 'Diskon Rp' },
  { value: 'percent', label: 'Diskon %' },
  { value: 'free_goods', label: 'Free Goods' },
] as const;

export const voucherListSelectParamsConfig: ParamConfig = {
  rewardType: {
    isMulti: false,
    defaultValue: '',
    options: VOUCHER_MECHANISM_OPTIONS,
  },
  statusVoucher: {
    isMulti: false,
    defaultValue: '',
    options: VOUCHER_STATUS_OPTIONS,
  },
};

/**
 * Default values for voucher creation form
 */
export const defaultValues: CreateVoucherRequest = {
  // Basic information
  banner_url: '',
  title: '',
  code: '',
  desc: '',
  period_start_date: '',
  period_end_date: '',

  // Target configuration
  target_configuration: {
    target_type: 'GENERAL',
    business_segmentations: [],
    distribution_channels: [],
    business_categories: [],
    shipto_csv_url: null,
    quota: 1,
    max_use_per_user: null,
  },

  // Acquisition configuration
  acquisition_configuration: {
    acquisition_type: 'REGULAR',
    valid_day_since_account_signup: null,
  },

  // Condition configuration
  condition_configuration: {
    condition_type: 'REGULAR',
    is_allow_combine_other_voucher: false,
    is_allow_combine_other_promo: false,
    is_allow_combine_other_special_price: false,
    min_purchase_amount: null,
  },

  // Reward configuration
  reward_configuration: {
    reward_type: 'DISCOUNT_PERCENT',
    min_total_quantity_all_item: 1,
    is_bundling: false,
    reward_rule_products: [],
    discount_products: [],
    free_goods: [],
    discount_amount_value: null,
    discount_percentage_value: null,
    free_goods_quantity_value: null,
  },

  // Form helpers
  codeValidated: false,
  shipToCsv: [],
  purchaseProducts: [],
  rewardDiscountProduct: null,
  rewardFreeProduct: null,
};
